import { render, staticRenderFns } from "./CurrVersions.vue?vue&type=template&id=760e51ca&"
import script from "./CurrVersions.vue?vue&type=script&lang=js&"
export * from "./CurrVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports